import React from 'react';
// import { Parallax, ParallaxBanner, ParallaxProvider } from 'react-scroll-parallax';
import { Parallax } from 'react-parallax';

function FullWidthImage({ className, img }) {
  return (
    <div>
      <div className={`${className || ''} d-none d-sm-none d-md-block d-xl-block w-100 full-width-img`}>
        <Parallax
          bgImage={img}
          bgImageSizes='cover'
          bgImageStyle={{
            objectFit: 'cover',
            objectPosition: '0 60%',
            width: '100%',
            height: '100%'
          }}
          strength={500}
          style={{
            width: '100%',
            height: '680px'
          }}
        />
      </div>
      <div className="d-md-none d-xl-none d-sm-block">
        <img src={img} />
      </div>
    </div>
  );
}

export default FullWidthImage;